import React, { useEffect, useState } from 'react';
import FormBuilderMultiControlsView from '../view/FormBuilderMultiControlsView';

const FormBuilderMultiControlsEngine = ({
  changeSelectedFields = () => {},
  dismiss = () => {},
  selectedCount = 0,
  canChangeAllToAdmin,
  selectedAreAllAdmin
}) => {
  const [currentRequired, setCurrentRequired] = useState(false);
  const [currentAdminOnly, setCurrentAdminOnly] = useState(selectedAreAllAdmin);

  useEffect(() => {
    if (selectedAreAllAdmin !== currentAdminOnly) {
      setCurrentAdminOnly(selectedAreAllAdmin);
    }
  }, [selectedAreAllAdmin, selectedCount]);

  const onRequiredToggled = () => {
    let newValue = !currentRequired;
    changeSelectedFields('required', newValue);
    setCurrentRequired(newValue);
  };
  const onAdminOnlyToggled = () => {
    let newValue = !currentAdminOnly;
    changeSelectedFields('adminonly', newValue);
    setCurrentAdminOnly(newValue);
  };

  const viewProps = {
    currentRequired,
    currentAdminOnly,
    dismiss,
    onAdminOnlyToggled,
    onRequiredToggled,
    selectedCount,
    visible: selectedCount > 0,
    canChangeAllToAdmin
  };

  return <FormBuilderMultiControlsView {...viewProps} />;
};

export default FormBuilderMultiControlsEngine;
